export const PLATFORM_COMPANY_ID = "00000000-0000-0000-0000-000000000001";
